import { useState, useEffect } from 'react'

import { getForms } from '../api'
import { GetFormsInput } from '../typings'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetFormsOnMount = (props: GetFormsInput) => {
  const dispatch = useAppDispatch()
  const { externalEntityId, externalEntityType } = props

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getForms({ externalEntityId, externalEntityType }),
        )

        if (mounted) {
          if (getForms.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading agreement forms.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, externalEntityId, externalEntityType])

  return status
}
